import { type FC } from 'react';
import { Navigate } from 'react-router-dom';

// Protected route admission remains owned by the enclosing member layout.
const CoachAIGate: FC = () => <Navigate to="/m" replace />;

export default CoachAIGate;
